import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';

export default function Link({ handleSettingsClick, item, index, isFormBuilder, relationFieldName, isRelation = false }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { subtext, required, label = 'Short Text' } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={
            isFormBuilder
              ? {}
              : {
                  required: required ? 'Required Field' : false,
                  pattern: {
                    value: /^(http|https):\/\/[^\s$.?#].[^\s]*$/,
                    message: 'Invalid URL. Please enter a valid http or https URL.',
                  },
                }
          }
          render={({ field, fieldState }) => (
            <InputText
              placeholder="http://example.com or https://example.com"
              id={field.name}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              value={field.value || ''}
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 new-task-popup input-shadow': true })}
              style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
              ref={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
